if (!kendo.data.binders.widget.custompromptlist) {
    kendo.data.binders.widget.custompromptlist = {};
}

/**
 * Two way binding that works on grid editing mode.
 *
 * Value is either the model of the row that should be edited or false if nothing should be edited.
 */
kendo.data.binders.widget.custompromptlist.responsive = kendo.data.Binder.extend({
    refresh: function() {
        this.element.setOptions({
            responsive: this.bindings.responsive.get()
        });
    }
});
